const alphabet = {
  '<': [
    0, 0, 1,
    0, 1, 0,
    1, 0, 0,
    0, 1, 0,
    0, 0, 1,
    0, 0, 0,
  ],
  '>': [
    1, 0, 0,
    0, 1, 0,
    0, 0, 1,
    0, 1, 0,
    1, 0, 0,
    0, 0, 0,
  ],
  '/': [
    0, 0, 0,
    0, 0, 1,
    0, 1, 0,
    0, 1, 0,
    1, 0, 0,
    0, 0, 0,
  ],
  ':': [
    0, 0, 0,
    0, 0, 0,
    0, 1, 0,
    0, 0, 0,
    0, 1, 0,
    0, 0, 0,
  ],
  '|': [
    0, 1, 0,
    0, 1, 0,
    0, 1, 0,
    0, 1, 0,
    0, 1, 0,
    0, 0, 0,
  ],
  '(': [
    0, 1,
    1, 0,
    1, 0,
    1, 0,
    0, 1,
    0, 0,
  ],
  ')': [
    1, 0,
    0, 1,
    0, 1,
    0, 1,
    1, 0,
    0, 0,
  ],
  0: [
    0, 1, 1,
    1, 0, 1,
    1, 0, 1,
    1, 0, 1,
    1, 1, 1,
    0, 0, 0,
  ],
  1: [
    1, 1, 0,
    0, 1, 0,
    0, 1, 0,
    0, 1, 0,
    1, 1, 1,
    0, 0, 0,
  ],
  2: [
    1, 1, 1,
    0, 0, 1,
    1, 1, 1,
    1, 0, 0,
    1, 1, 1,
    0, 0, 0,
  ],
  3: [
    1, 1, 1,
    0, 0, 1,
    0, 1, 1,
    0, 0, 1,
    1, 1, 1,
    0, 0, 0,
  ],
  4: [
    1, 0, 1,
    1, 0, 1,
    1, 1, 1,
    0, 0, 1,
    0, 0, 1,
    0, 0, 0,
  ],
  5: [
    1, 1, 1,
    1, 0, 0,
    1, 1, 1,
    0, 0, 1,
    1, 1, 1,
    0, 0, 0,
  ],
  6: [
    1, 0, 0,
    1, 0, 0,
    1, 1, 1,
    1, 0, 1,
    1, 1, 1,
    0, 0, 0,
  ],
  7: [
    1, 1, 1,
    0, 0, 1,
    0, 0, 1,
    0, 0, 1,
    0, 0, 1,
    0, 0, 0,
  ],
  8: [
    1, 1, 1,
    1, 0, 1,
    1, 1, 1,
    1, 0, 1,
    1, 1, 1,
    0, 0, 0,
  ],
  9: [
    1, 1, 1,
    1, 0, 1,
    1, 1, 1,
    0, 0, 1,
    0, 0, 1,
    0, 0, 0,
  ],

  ' ': [
    0, 0,
    0, 0,
    0, 0,
    0, 0,
    0, 0,
    0, 0
  ],
  '.': [
    0,
    0,
    0,
    0,
    1,
    0,
  ],
  ',': [
    0,
    0,
    0,
    0,
    1,
    1,
  ],
  '+': [
    0, 0, 0,
    0, 1, 0,
    1, 1, 1,
    0, 1, 0,
    0, 0, 0,
    0, 0, 0
  ],
  '-': [
    0, 0, 0,
    0, 0, 0,
    1, 1, 1,
    0, 0, 0,
    0, 0, 0,
    0, 0, 0
  ],
  '!': [
    1,
    1,
    1,
    0,
    1,
    0,
  ],
  '?': [
    1, 1,
    0, 1,
    1, 1,
    0, 0,
    1, 0,
    0, 0,
  ],
  a: [
    1, 1, 1,
    1, 0, 1,
    1, 1, 1,
    1, 0, 1,
    1, 0, 1,
    0, 0, 0
  ],
  b: [
    1, 1, 0,
    1, 0, 1,
    1, 1, 0,
    1, 0, 1,
    1, 1, 1,
    0, 0, 0
  ],
  c: [
    1, 1, 1,
    1, 0, 0,
    1, 0, 0,
    1, 0, 0,
    1, 1, 1,
    0, 0, 0
  ],
  d: [
    1, 1, 0,
    1, 0, 1,
    1, 0, 1,
    1, 0, 1,
    1, 1, 1,
    0, 0, 0
  ],
  e: [
    1, 1, 1,
    1, 0, 0,
    1, 1, 1,
    1, 0, 0,
    1, 1, 1,
    0, 0, 0
  ],
  f: [
    1, 1, 1,
    1, 0, 0,
    1, 1, 1,
    1, 0, 0,
    1, 0, 0,
    0, 0, 0
  ],
  g: [
    1, 1, 1,
    1, 0, 0,
    1, 0, 1,
    1, 0, 1,
    1, 1, 1,
    0, 0, 0
  ],
  h: [
    1, 0, 1,
    1, 0, 1,
    1, 1, 1,
    1, 0, 1,
    1, 0, 1,
    0, 0, 0
  ],
  i: [
    1, 1, 1,
    0, 1, 0,
    0, 1, 0,
    0, 1, 0,
    1, 1, 1,
    0, 0, 0
  ],
  j: [
    0, 0, 1,
    0, 0, 1,
    0, 0, 1,
    1, 0, 1,
    1, 1, 1,
    0, 0, 0
  ],
  k: [
    1, 0, 1,
    1, 0, 1,
    1, 1, 0,
    1, 0, 1,
    1, 0, 1,
    0, 0, 0
  ],
  l: [
    1, 0, 0,
    1, 0, 0,
    1, 0, 0,
    1, 0, 0,
    1, 1, 1,
    0, 0, 0
  ],
  m: [
    1, 0, 1,
    1, 1, 1,
    1, 1, 1,
    1, 0, 1,
    1, 0, 1,
    0, 0, 0
  ],
  n: [
    1, 1, 1,
    1, 0, 1,
    1, 0, 1,
    1, 0, 1,
    1, 0, 1,
    0, 0, 0
  ],
  o: [
    1, 1, 1,
    1, 0, 1,
    1, 0, 1,
    1, 0, 1,
    1, 1, 1,
    0, 0, 0
  ],
  p: [
    1, 1, 1,
    1, 0, 1,
    1, 1, 1,
    1, 0, 0,
    1, 0, 0,
    0, 0, 0
  ],
  q: [
    1, 1, 1,
    1, 0, 1,
    1, 0, 1,
    1, 0, 1,
    0, 1, 1,
    0, 0, 0
  ],
  r: [
    1, 1, 1,
    1, 0, 1,
    1, 1, 0,
    1, 0, 1,
    1, 0, 1,
    0, 0, 0
  ],
  s: [
    1, 1, 1,
    1, 0, 0,
    1, 1, 1,
    0, 0, 1,
    1, 1, 1,
    0, 0, 0
  ],
  t: [
    1, 1, 1,
    0, 1, 0,
    0, 1, 0,
    0, 1, 0,
    0, 1, 0,
    0, 0, 0
  ],
  u: [
    1, 0, 1,
    1, 0, 1,
    1, 0, 1,
    1, 0, 1,
    1, 1, 1,
    0, 0, 0
  ],
  v: [
    1, 0, 1,
    1, 0, 1,
    1, 0, 1,
    1, 0, 1,
    1, 1, 0,
    0, 0, 0
  ],
  w: [
    1, 0, 1,
    1, 0, 1,
    1, 1, 1,
    1, 1, 1,
    1, 0, 1,
    0, 0, 0
  ],
  x: [
    1, 0, 1,
    1, 0, 1,
    0, 1, 0,
    1, 0, 1,
    1, 0, 1,
    0, 0, 0
  ],
  y: [
    1, 0, 1,
    1, 0, 1,
    1, 1, 1,
    0, 0, 1,
    1, 1, 1,
    0, 0, 0
  ],
  z: [
    1, 1, 1,
    0, 0, 1,
    0, 1, 0,
    1, 0, 0,
    1, 1, 1,
    0, 0, 0
  ],
}

export default alphabet



// WEBPACK FOOTER //
// ./src/contextCanvasAPI/alphabet.js